<ng-container *ngIf="isOpen">
  <section class="snack-bar-root no-print" [attr.data-successful]="snackBarSuccessful" [attr.data-warn]="snackBarWarn">
    <span class="body-text">{{snackMessage}}</span>
    <button (click)="closeSnackBar()">✕</button>
  </section>
</ng-container>
